import { getCityLocation } from './locationCatalog';

// Canonical province hub: /<provinceId> for every province (e.g. /ontario, /quebec).
export const getProvinceCatalogPath = (provinceId) => `/${encodeURIComponent(provinceId || 'ontario')}`;

// Canonical city page: /<provinceId>/<citySlug> (e.g. /quebec/montreal).
// Resolves the province from the delivery-area catalogue; falls back to Ontario
// when the city is unknown so legacy callers keep working.
export const getCityCatalogPath = (citySlugValue, provinceId = '') => {
  const resolved = provinceId || getCityLocation(citySlugValue)?.provinceId || 'ontario';
  return `/${encodeURIComponent(resolved)}/${encodeURIComponent(citySlugValue)}`;
};
